module.exports = __webpack_public_path__ + "static/media/welcome.0000d57b.png";